import { HttpService } from './http-base.service';

export default class FeedbackService extends HttpService {
  constructor(baseURL) {
    if (!FeedbackService.instance) {
      super(baseURL);
      FeedbackService.instance = this;
    }

    return FeedbackService.instance;
  }

  submitAiSummary({ feedbackType, placeId, summary, feedbackTags = [] }) {
    return this.post('/api/feedback/v1', {
      feedbackType,
      placeId,
      summary,
      feedbackTags,
    });
  }
}
